// frontend/src/components/staff/FreeformBodyEditor.js
//
// MAILCHIMP-COMMS-001-B — Freeform rich-text body editor.
// Spec: docs/design/MAILCHIMP-COMMS-001-A-design.md §3.6.3.
//
// Constrained Quill toolbar: Bold, Italic, Link, Bulleted list, Numbered list.
// No image upload, no font/color/header — intentional brand-voice + scope
// restriction. The BE re-sanitizes via DOMPurify before persistence + dispatch
// regardless of what this editor produces.

import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./FreeformBodyEditor.css";

const TOOLBAR = [
  ["bold", "italic"],
  ["link"],
  [{ list: "ordered" }, { list: "bullet" }],
  ["clean"],
];

const FORMATS = ["bold", "italic", "link", "list", "bullet"];

const FreeformBodyEditor = ({
  value,
  onChange,
  charCount,
  counterStage,
  softWarnAt,
  hardBlockAt,
}) => {
  const helper = (() => {
    if (counterStage === "block") {
      return `Body is too long (>${hardBlockAt} characters). Trim to send.`;
    }
    if (counterStage === "warn") {
      return `Approaching length limit (~${softWarnAt}+ characters).`;
    }
    return "";
  })();

  return (
    <div className="broadcast-freeform-editor">
      <label
        className="broadcast-freeform-label"
        htmlFor="broadcast-freeform-quill"
      >
        Message body
      </label>
      <div
        id="broadcast-freeform-quill"
        className="broadcast-freeform-quill"
        aria-label="Email body editor"
      >
        <ReactQuill
          theme="snow"
          modules={{ toolbar: TOOLBAR }}
          formats={FORMATS}
          value={value}
          onChange={onChange}
          placeholder="Write your message... Keep it concise — most customers read on mobile."
        />
      </div>
      <div
        className={`broadcast-char-counter stage-${counterStage}`}
        aria-live="polite"
      >
        {charCount} character{charCount === 1 ? "" : "s"}
      </div>
      {helper && (
        <div
          className={`broadcast-freeform-helper stage-${counterStage}`}
          role={counterStage === "block" ? "alert" : "status"}
        >
          {helper}
        </div>
      )}
    </div>
  );
};

export default FreeformBodyEditor;
